export const S3_LINK_URI = process.env.REACT_APP_S3_URL; //'https://linkstory.s3.amazonaws.com/';
export const PLACEHOLDER_IMG =
  'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
